var chunkMapping = {
	"3": [
		1375
	],
	"38": [
		6565
	],
	"72": [
		7072
	],
	"166": [
		7573
	],
	"234": [
		947
	],
	"244": [
		681
	],
	"365": [
		4355
	],
	"421": [
		5735
	],
	"464": [
		3637
	],
	"529": [
		2843
	],
	"659": [
		865
	],
	"703": [
		8773
	],
	"741": [
		5895
	],
	"791": [
		6113
	],
	"891": [
		5457
	],
	"990": [
		2117
	],
	"993": [
		6045
	]
};
var idToExternalAndNameMapping = {
	"681": [
		"default",
		"./HeaderApp",
		6480
	],
	"865": [
		"default",
		"./EcommerceApp",
		8124
	],
	"947": [
		"default",
		"./AuthApp",
		638
	],
	"1375": [
		"default",
		"./BookingBuilderApp",
		9890
	],
	"2117": [
		"default",
		"./EmailBuilderApp",
		1944
	],
	"2843": [
		"default",
		"./CustomerAuthenticationApp",
		7338
	],
	"3637": [
		"default",
		"./DynamicFormsAdminApp",
		9084
	],
	"4355": [
		"default",
		"./DynamicFormsApp",
		2266
	],
	"5457": [
		"default",
		"./SidebarApp",
		924
	],
	"5735": [
		"default",
		"./ServicesApp",
		9718
	],
	"5895": [
		"default",
		"./WebsiteBuilderApp",
		5126
	],
	"6045": [
		"default",
		"./POSApp",
		1612
	],
	"6113": [
		"default",
		"./MarketingApp",
		5580
	],
	"6565": [
		"default",
		"./OffersApp",
		2080
	],
	"7072": [
		"default",
		"./IdleSessionApp",
		92
	],
	"7573": [
		"default",
		"./POSBackOfficeApp",
		2864
	],
	"8773": [
		"default",
		"./ProductManagementApp",
		7888
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}